import { Box } from "@mui/material";
import SiteTopicDistributionWrapper from "./SiteTopicDistributionWrapper";

function SiteStatisticsPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      maxWidth="false"
      maxHeight="false"
      alignItems="center"
      width="100%"
      className=""
    >
      <Box
        display="flex"
        flexDirection="column"
        maxWidth="false"
        maxHeight="false"
        alignItems="center"
        width="100%"
        sx={{ flexShrink: 1 }}
      >
        <SiteTopicDistributionWrapper></SiteTopicDistributionWrapper>
      </Box>
    </Box>
  );
}

export default SiteStatisticsPage;
